<template>
  <PInputTextStyles />
  <InputText v-bind="$attrs">
    <template v-for="(_, slotName) in $slots" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps ?? {}" />
    </template>
  </InputText>
</template>

<script setup lang="ts">
import type { InputTextEmits, InputTextProps } from "primevue";

import { InputText } from "primevue";

import PInputTextStyles from "./PInputTextStyles.vue";

defineOptions({ inheritAttrs: false });
defineProps</* @vue-ignore */ InputTextProps>();
defineEmits</* @vue-ignore */ InputTextEmits>();
</script>
